import { WixPatternsEssentials } from '@wix/bex-core';
import {
  HttpClient,
  RequestOptionsFactory,
  HttpResponse,
} from '@wix/sdk-types';
import { WixClient } from '@wix/sdk-react';

export function createWixHttpClient(client: Pick<WixClient, 'use'>) {
  return {
    request: (req) =>
      client.use(
        (
          httpClient: HttpClient = {
            request: async () => ({} as HttpResponse),
          },
        ) =>
          httpClient.request(
            (typeof req === 'function'
              ? req
              : () => req) as RequestOptionsFactory,
          ),
      ),
  } as WixPatternsEssentials['httpClient'];
}
